<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="vi_username"
      placeholder="输入来访人进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/visit_inner/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.vi_username }}</p>
          <p class="list-item-muted">{{ item.vi_visittime }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.vi_corpname }}</p>
          <span
            class="list-item-status"
            :class="{ warning: item.vi_status != 1 }"
            >{{ item.status }}</span
          >
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}次</label>
    </div>
    <add-button to="/oa/visit_inner_qrcode" icon="iconfont icon-qrcode"/>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/visit_inner/list",
      filters: [
        {
          type: "date",
          name: "vi_visittime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待确认",
              condition: "vi_status=0",
            },
            {
              value: 2,
              label: "已同意",
              condition: "vi_status=1",
            },
            {
              value: 2,
              label: "已拒绝",
              condition: "vi_status=2",
            },
          ],
        },
      ],
    };
  },
};
</script>